export const paymentTypes = {
  payment: 'Om.Shared.CommonObjects.Payment, Om.Shared.CommonObjects',
  discount: 'Om.Shared.CommonObjects.Discount, Om.Shared.CommonObjects',
  refund: 'Om.Shared.CommonObjects.Refund, Om.Shared.CommonObjects',
};
